module.exports = __webpack_public_path__ + "img/electrician.cb3c7249.jpg";